export default () => {
  const navHeadings = document.querySelectorAll('[data-nav-heading]');

  const handleMouseover = (e) => {
    const el = e.currentTarget;
    const menu = el.querySelector('[data-heading-menu]');
    const scrollHeight = menu.scrollHeight;
    const lazyImages = el.querySelectorAll('[data-src]');

    menu.style.maxHeight = `${scrollHeight}px`;

    lazyImages.forEach((item) => {
      item.setAttribute('src', item.getAttribute('data-src'));
      item.removeAttribute('data-src');
    });
  };

  const handleMouseleave = (e) => {
    const el = e.currentTarget;
    const menu = el.querySelector('[data-heading-menu]');
    menu.style.maxHeight = '0px';
  };

  navHeadings.forEach((heading) => {
    heading.addEventListener('mouseover', handleMouseover);
    heading.addEventListener('mouseleave', handleMouseleave);
  });
};
